module.exports = __webpack_public_path__ + "static/media/spin-win-market.fcaaef05.png";